import React, { useEffect } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import Navbar from "@/components/Navbar";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const { id: requestId } = useParams();
  const sessionId = sp.get("session_id");
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          toast.success("¡Pago confirmado! Depósito en garantía.");
          setTimeout(() => nav(`/request/${requestId}`, { replace: true }), 800);
          return;
        }
      } catch (e) { console.warn("payment status poll failed", e); }
      if (attempts < 15) setTimeout(poll, 2000);
      else nav(`/request/${requestId}`, { replace: true });
    };
    poll();
  }, [sessionId, requestId, nav]);

  return (
    <div className="min-h-screen hub-cream">
      <Navbar/>
      <div className="max-w-md mx-auto p-16 text-center">
        <CheckCircle2 className="mx-auto text-emerald-500 mb-4" size={48}/>
        <h1 className="font-serif text-3xl text-[#0B1D3A]">Confirmando tu pago...</h1>
        <p className="text-[#5C6B7D] mt-2 text-sm">No cierres esta ventana. Te llevamos de vuelta al trabajo.</p>
      </div>
    </div>
  );
}
